export const wheelGame = {
  freeSpin: 'Giro gratis',
  viewHistory: 'Ver historial',
  date: 'Fecha',
  type: 'Tipo',
  amount: 'Cantidad',
  spinFor: 'Girar por',
  dateFrom: 'Fecha desde',
  dateTo: 'Fecha hasta',
  from: 'Desde',
  to: 'Hasta',
  show: 'Mostrar',
  page: 'Página',
  spin: 'Girar',
  selectPeriod: 'Seleccionar periodo',
  claim: 'Reclamar',
  spinHistory: 'Historial de giros',
  nextFreeSpin: 'Próximo giro gratis',
  youHaveNotWinYet: 'Aún no has ganado nada',
  youWon: 'Ganaste',
  luckyNextTime: 'Tendrás suerte la próxima vez',
  tryAgain: 'Inténtalo de nuevo',
  seconds: 'Segundos',
  minutes: 'Minutos',
  hours: 'Horas',
}
